import Collapse from './Collapse';
export default Collapse;


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/collapse/index.js
// module id = 1291
// module chunks = 0